import React, { CSSProperties } from 'react';
import { View } from './View';
import { Icon } from './Icon';
import { Button2 } from './Button2';
import { colors } from '../colors';

interface TextInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  name: string;
  width?: string;
  leftIconName?: string;
  rightIcon?: string;
  handlePasswordVisibility?: () => void;
}

export const TextInput: React.FC<TextInputProps> = ({
  name,
  width = '100%',
  leftIconName,
  rightIcon,
  handlePasswordVisibility,
  ...otherProps
}) => {
  const containerStyle: CSSProperties = {
    backgroundColor: colors.white,
    borderRadius: '8px',
    display: 'flex',
    flexDirection: 'row',
    padding: '12px',
    marginTop: '12px',
    marginBottom: '12px',
    width,
    border: `1px solid ${colors.mediumGray}`,
    alignItems: 'center',
  };

  const inputStyle: CSSProperties = {
    flex: 1,
    width: '100%',
    fontSize: '18px',
    color: colors.black,
    border: 'none',
    outline: 'none',
    backgroundColor: 'transparent',
  };

  return (
    <View style={containerStyle}>
      {leftIconName ? (
        <Icon
          name={leftIconName}
          size={22}
          color={colors.mediumGray}
          style={{ marginRight: '10px' }}
        />
      ) : null}
      <input
        name={name}
        style={inputStyle}
        {...otherProps}
      />
      {rightIcon ? (
        <Button2 onPress={handlePasswordVisibility}>
          <Icon
            name={rightIcon}
            size={22}
            color={colors.mediumGray}
            style={{ marginRight: '10px' }}
          />
        </Button2>
      ) : null}
    </View>
  );
};
